// @flow
import React from 'react';

export default function FilterDefaultLogo() {
    return (
        <div className="logo filter-default-logo">
            <img
                alt="Heroic-Logo"
                src="https://static.trainheroic.com/images/h_white.png"
            />
        </div>
    );
}
